import { useState } from 'react';
import * as service from '../services';
import { useSetupInfoAnaliseDeCoberturaStore } from '../SetupInfoPanelAnaliseDeCobertura.store';
import { UploadState } from '../@types';
import * as utils from '../utils';

export const useUploadCoverageFiles = () => {
  const [uploadProgress, setUploadProgress] = useState(0);
  const { setSetupInfoAnaliseDeCoberturaState, draftCoverageSetupData } = useSetupInfoAnaliseDeCoberturaStore();

  const controller = new AbortController();

  const simulateUpload = () => {
    setUploadProgress(0);

    const duration = 1250;
    const interval = 100;
    const steps = duration / interval;
    let currentProgress = 0;

    const timer = setInterval(() => {
      currentProgress += 100 / steps;

      if (currentProgress >= 100) {
        clearInterval(timer);
        setUploadProgress(99);
      } else {
        setUploadProgress(Math.min(currentProgress, 99));
      }
    }, interval);
  };

  const validateUploadProductFile = async (file: File) => {
    simulateUpload();
    setSetupInfoAnaliseDeCoberturaState('uploadState', UploadState.UPLOADING);

    const formData = new FormData();
    formData.append('file', file);

    try {
      const resp = await service.draftUploadProduct(formData, controller);
      const data = resp.data;

      const draftCoverage = {
        ...draftCoverageSetupData,
        dataEnvioGtins: data.dataEnvio,
        usuarioEnvioGtins: data.usuario,
        nomeArquivoGtins: data.nomeArquivo,
      };
      setSetupInfoAnaliseDeCoberturaState('productUploadResponse', resp.data);
      setSetupInfoAnaliseDeCoberturaState('draftCoverageSetupData', draftCoverage);

      utils.setModalUploadStatus('PRODUTO', resp, setSetupInfoAnaliseDeCoberturaState);
    } catch (error) {
      setSetupInfoAnaliseDeCoberturaState('uploadState', UploadState.WRONG_FILE);
    }
  };

  const validateUploadLojaFile = async (file: File) => {
    simulateUpload();
    setSetupInfoAnaliseDeCoberturaState('uploadState', UploadState.UPLOADING);

    const formData = new FormData();
    formData.append('file', file);

    try {
      const resp = await service.draftUploadStore(formData, controller);
      const data = resp.data;

      const draftCoverage = {
        ...draftCoverageSetupData,
        dataEnvioLojas: data.dataEnvio,
        usuarioEnvioLojas: data.usuario,
        nomeArquivoLojas: data.nomeArquivo,
      };

      setSetupInfoAnaliseDeCoberturaState('lojaUploadResponse', resp.data);
      setSetupInfoAnaliseDeCoberturaState('draftCoverageSetupData', draftCoverage);

      utils.setModalUploadStatus('LOJA', resp, setSetupInfoAnaliseDeCoberturaState);
    } catch (error) {
      setSetupInfoAnaliseDeCoberturaState('uploadState', UploadState.WRONG_FILE);
    }
  };

  const cancelUploadProductFile = () => {
    controller.abort();
  };

  return {
    uploadProgress,
    cancelUploadProductFile,
    validateUploadProductFile,
    validateUploadLojaFile,
  };
};
